import { render, staticRenderFns } from "./QueryColumn.vue?vue&type=template&id=a5211672"
import script from "./QueryColumn.vue?vue&type=script&lang=js"
export * from "./QueryColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports